export default "__VITE_ASSET__D8Yx$pF8__"